export const getters = {
  adCar (state) {
    return state.adCar
  },
  loggedUser (state) {
    return state.auth.loggedUser
  },
  accessToken (state) {
    return state.auth.accessToken
  },
  locale (state) {
    return state.locale
  },
  currencies (state) {
    return state.currencies
  },
  currency (state) {
    return state.currency
  },
  alert (state) {
    return state.alert
  },
  appVersion (state) {
    return state.appVersion
  },
  buildTime (state) {
    return state.buildTime
  },
  appName (state) {
    return state.appName
  },
  uiConf (state) {
    return state.uiConf
  }
}
